import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ProjectFeature } from '../common/models/ProjectFeature';
import { ProjectFeatureService } from '../services/project-feature.service';

function getProjectSlug(route: ActivatedRouteSnapshot): string | null {
  const slug = route.paramMap.get('slug');
  if (slug) return slug;
  return route.parent ? getProjectSlug(route.parent) : null;
}

export const projectFeaturesResolver: ResolveFn<ProjectFeature[]> = (
  route: ActivatedRouteSnapshot
) => {
  const projectSlug = getProjectSlug(route);
  if (!projectSlug) return of([]);
  return inject(ProjectFeatureService).refresh(projectSlug).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        inject(Router).navigate(['/login']);
      }
      return of([]);
    })
  );
};
